import { render } from "./ProposalCreate.vue?vue&type=template&id=7545cba6&scoped=true&ts=true"
import script from "./ProposalCreate.vue?vue&type=script&lang=ts"
export * from "./ProposalCreate.vue?vue&type=script&lang=ts"

import "./ProposalCreate.vue?vue&type=style&index=0&id=7545cba6&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7545cba6"]])

export default __exports__